var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 4",
    fill: "#3d60d3",
    stroke: "#3d60d3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(-26 -28)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(26 28)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(34 28)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(42 28)",
    stroke: "none"
  }))));
};
export default SvgMore;